import { useState } from 'react'
import './ActivityList.less'
import useHistory from '@/hooks/useHistory'


const ActivityList = () => {
  const history = useHistory()

  const [list, setList] = useState([
    {id: '01', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/activity/list-01.png'},
    {id: '02', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/activity/list-02.png'},
    {id: '03', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/activity/list-03.png'},
    {id: '04', url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/activity/list-04.png'},
  ])

  const handleClick = (id) => {
    history.push('/ActivityDetail?id=' + id)
  } 
  return (
    <div className='pg-activity-list'>
      {
        list.map((item, index) => {
          return <img className='img' key={ index } src={item.url} onClick={() => handleClick(item.id)} />
        })
      }
    </div>
  )
}

export default ActivityList